<script>
  import { domainName, record } from '../stores.js';
  import ContactUsForm from '../ContactUsForm.svelte';

  let createDkim = false;
</script>

<div class="record-box record-404">
  <div id="headingRaw" class="box-label">
    <h5 class="mb-3">No DKIM record found for <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <p>This domain does not have a TXT record published.</p>
    <button on:click|preventDefault={() => createDkim = true} disabled={createDkim} class="btn btn-1" id="create-dkim">Create DKIM Record</button>
  </div>
  {#if createDkim}
    <div class="box-detail found-no-record">
      <ContactUsForm />
    </div>
  {/if}
</div>

<style>

</style>
